var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.4 371.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#014694;}.cls-2{fill:#0149b0;}.cls-3{fill:#f0f0f0;}.cls-4{fill:#d37c07;}.cls-5{fill:#fff;}.cls-6{fill:#fdbb01;}.cls-7{fill:#191614;}.cls-8{fill:#39302a;}.cls-9{fill:#8383e8;}.cls-10{fill:#fb9b38;}.cls-11{fill:#9c4721;}.cls-12{fill:#053d75;}.cls-13{isolation:isolate;}.cls-14{fill:#d4d1d0;}.cls-15{fill:#d6d6d6;}.cls-16{fill:#ff7b6c;}.cls-17{fill:#fdd0db;}.cls-18{fill:#ffbb4a;}.cls-19{fill:#fd6348;}.cls-20{fill:#e25946;}.cls-21{fill:#699fd9;}.cls-22{fill:#3069bf;}.cls-23{fill:#2b4b64;}.cls-24{fill:#d9502a;}.cls-25{fill:#006eb0;}.cls-26{fill:#e6b6c3;}.cls-27{fill:#cb7c61;}.cls-28{fill:#f0af11;}.cls-29{fill:#ff6b48;}.cls-30{fill:#a3240a;}.cls-31{fill:#f8dfe6;}.cls-32{fill:#fbda55;}.cls-33{fill:#f0eeed;}.cls-34{fill:#c7c5c5;}.cls-35{fill:#719ac2;}.cls-36,.cls-37{fill:#08263f;}.cls-38{fill:#773d41;}.cls-39{fill:#242663;}.cls-40{fill:#e5e5e5;}.cls-41{fill:#1c1a19;}.cls-42{fill:#f39273;}.cls-43{fill:#4e423c;}.cls-44{fill:#abe60e;}.cls-45{fill:#f05c2d;}.cls-46{fill:#8c494c;}.cls-37{mix-blend-mode:hard-light;opacity:.3;}.cls-47{fill:#6b69df;}.cls-48{fill:#87371c;}.cls-49{fill:#017bd4;}.cls-50{fill:#d2940f;}.cls-51{fill:#bb1623;}.cls-52{fill:#f59473;}.cls-53{fill:#97b9de;}.cls-54{fill:#ec8a02;}.cls-55{fill:#bdbbbb;}.cls-56{fill:#e0dfde;}.cls-57{fill:#99bde3;}.cls-58{fill:#5c4f47;}.cls-59{fill:#9b5d61;}.cls-60{fill:#fd3900;}.cls-61{fill:#9dcfe5;}.cls-62{fill:#c3dcfd;}.cls-63{fill:#5c5cc4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "329.86 295.23 384.4 263.75 326.36 230.4 297.88 246.78 209.41 195.95 89.67 264.79 54.19 244.4 0 275.56 57.69 309.23 103.81 282.61 170.87 321.76 151.51 332.89 217.72 371.19 287.19 331.08 267.87 320.1 320.46 289.75 329.86 295.23"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "238.96 214.32 226.42 207.25 228.14 206.26 175.15 175.53 145.8 192.48 198.99 223.09 220.92 210.43 233.23 217.71 238.96 214.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "300.09 224.56 312.33 217.49 265.04 191.32 253.08 198.22 205.97 171.83 185.83 183.43 312.06 255.09 333.03 243.02 300.09 224.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "369.36 241.08 369.36 101.17 196.91 1.6 196.91 141.51 259.07 177.41 259.02 177.38 259.03 197.41 236.92 210.18 276.32 232.9 302.98 217.51 280.8 205.24 280.88 190 369.36 241.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "196.91 1.6 199.69 0 372.67 99.44 372.53 239.18 369.36 241.08 369.36 101.17 196.91 1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "369.36 101.17 372.67 99.44 372.53 239.18 369.36 241.08 369.36 101.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "369.36 110.69 196.91 11.12 196.91 1.6 369.36 101.17 369.36 110.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M204.3,10.63c0,.87-.71,1.17-1.58,.67-.87-.5-1.58-1.62-1.58-2.49s.71-1.17,1.58-.67c.87,.5,1.58,1.62,1.58,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.69,14.32c0,.87-.71,1.17-1.58,.67-.87-.5-1.58-1.62-1.58-2.49s.71-1.17,1.58-.67c.87,.5,1.58,1.62,1.58,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M217.08,18.01c0,.87-.71,1.17-1.58,.67-.87-.5-1.58-1.62-1.58-2.49s.71-1.17,1.58-.67c.87,.5,1.58,1.62,1.58,2.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "289.55 187.78 200.91 136.61 200.91 20.72 289.55 71.9 289.55 187.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "365.07 231.38 318.19 204.32 318.19 88.44 365.07 115.5 365.07 231.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "236.94 73.67 205.36 55.44 205.36 28.56 236.94 46.79 236.94 73.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "358.7 143.97 324.56 124.26 324.56 97.38 358.7 117.09 358.7 143.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "358.7 222.81 324.56 203.1 324.56 162.87 358.7 182.58 358.7 222.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "358.7 146.03 324.56 126.31 324.56 124.26 358.7 143.97 358.7 146.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "358.7 154.26 324.56 134.55 324.56 133.8 358.7 153.52 358.7 154.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "358.7 159.38 324.56 139.66 324.56 138.92 358.7 158.63 358.7 159.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "358.7 164.5 324.56 144.78 324.56 144.04 358.7 163.75 358.7 164.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "358.7 169.62 324.56 149.9 324.56 149.16 358.7 168.87 358.7 169.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "358.7 174.74 324.56 155.02 324.56 154.28 358.7 173.99 358.7 174.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "358.7 219.35 324.56 199.63 324.56 198.89 358.7 218.6 358.7 219.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "312.98 201.31 287.95 186.86 287.95 70.97 312.98 85.43 312.98 201.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "285.08 137.23 205.36 91.21 205.36 64.33 285.08 110.35 285.08 137.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "309.93 134.15 290.52 122.94 290.52 113.49 309.93 124.7 309.93 134.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "285.08 176.1 205.36 130.07 205.36 103.19 285.08 149.22 285.08 176.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "251.11 60.4 240.03 54.39 240.03 52.8 251.11 58.81 251.11 60.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "278.23 83.21 240.03 61.55 240.03 59.96 278.23 81.62 278.23 83.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "278.23 90.36 240.03 68.7 240.03 67.11 278.23 88.77 278.23 90.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "278.23 97.51 240.03 75.85 240.03 74.26 278.23 95.92 278.23 97.51"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 341.63,
    cy: 190.69,
    rx: 5.35,
    ry: 9.46,
    transform: "translate(-46.02 243.65) rotate(-36.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "339.47 189.8 339.47 186.43 342.39 189.8 345.31 193.18 342.39 193.18 339.47 193.18 339.47 189.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M298.31,86.05c0,2.15-1.74,2.89-3.89,1.65-2.15-1.24-3.89-3.99-3.89-6.14s1.74-2.89,3.89-1.65c2.15,1.24,3.89,3.99,3.89,6.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 93.14 300.46 87.67 300.46 86.93 309.93 92.39 309.93 93.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M298.31,97.9c0,2.15-1.74,2.89-3.89,1.65-2.15-1.24-3.89-3.99-3.89-6.14s1.74-2.89,3.89-1.65c2.15,1.24,3.89,3.99,3.89,6.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 104.98 300.46 99.51 300.46 98.77 309.93 104.23 309.93 104.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M298.31,109.74c0,2.15-1.74,2.89-3.89,1.65-2.15-1.24-3.89-3.99-3.89-6.14s1.74-2.89,3.89-1.65c2.15,1.24,3.89,3.99,3.89,6.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 116.82 300.46 111.36 300.46 110.61 309.93 116.08 309.93 116.82"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M307.22,186.09c0,3.86-3.13,5.19-7,2.96-3.86-2.23-7-7.17-7-11.04s3.13-5.19,7-2.96c3.86,2.23,7,7.17,7,11.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 138.51 290.52 127.3 290.52 126.56 309.93 137.77 309.93 138.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 143.3 290.52 132.09 290.52 131.35 309.93 142.56 309.93 143.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 148.09 290.52 136.88 290.52 136.14 309.93 147.34 309.93 148.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "309.93 163.87 290.52 152.66 290.52 143.21 309.93 154.42 309.93 163.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 168.23 290.52 157.02 290.52 156.28 309.93 167.49 309.93 168.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 173.02 290.52 161.81 290.52 161.07 309.93 172.27 309.93 173.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "309.93 177.81 290.52 166.6 290.52 165.85 309.93 177.06 309.93 177.81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 110.67 226.19 82.48 226.19 81.74 275 109.93 275 110.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 115.79 226.19 87.6 226.19 86.86 275 115.04 275 115.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 120.91 226.19 92.72 226.19 91.98 275 120.16 275 120.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 126.03 226.19 97.84 226.19 97.1 275 125.28 275 126.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 149.53 226.19 121.35 226.19 120.61 275 148.79 275 149.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 154.65 226.19 126.47 226.19 125.72 275 153.91 275 154.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 159.77 226.19 131.59 226.19 130.84 275 159.03 275 159.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "275 164.89 226.19 136.71 226.19 135.96 275 164.15 275 164.89"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "236.92 210.18 236.92 211.93 276.28 234.69 302.98 219.35 302.98 217.51 276.32 232.9 236.92 210.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "284.24 207.14 284.24 220.14 296.09 213.73 284.24 207.14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M209.37,91.97c.12-.07,.25-.13,.38-.18h0s.04-.01,.04-.01c0,0,0,0,0,0l1.59-.63h0c2.15-.85,5.28,.98,7.2,4.31,2.03,3.52,1.94,7.38-.21,8.62-.1,.06-.21,.11-.32,.16h0l-.09,.04s-.01,0-.02,0l-1.64,.64h0c-2.15,.81-5.25-1.03-7.15-4.33-2.03-3.52-1.94-7.38,.21-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M209.44,100.43c1.92,3.33,5.09,5.09,7.09,3.94,1.99-1.15,2.05-4.78,.13-8.11-1.92-3.33-5.09-5.09-7.09-3.94-1.99,1.15-2.05,4.78-.13,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M208.86,93.28c-.57,1.76-.14,4.36,1.27,6.81,1.28,2.22,3.06,3.79,4.73,4.36-1.74-.32-3.72-1.88-5.07-4.22-1.48-2.56-1.78-5.3-.93-6.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M208.55,128.1c.12-.07,.25-.13,.38-.18h0s.04-.01,.04-.01c0,0,0,0,0,0l1.59-.63h0c2.15-.85,5.28,.98,7.2,4.31,2.03,3.52,1.94,7.38-.21,8.62-.1,.06-.21,.11-.32,.16h0s-.09,.04-.09,.04c0,0-.01,0-.02,0l-1.64,.64h0c-2.15,.81-5.25-1.03-7.15-4.33-2.03-3.52-1.94-7.38,.21-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M208.62,136.55c1.92,3.33,5.09,5.09,7.09,3.94,1.99-1.15,2.05-4.78,.13-8.11-1.92-3.33-5.09-5.09-7.09-3.94s-2.05,4.78-.13,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M208.04,129.4c-.57,1.76-.14,4.36,1.27,6.81,1.28,2.22,3.06,3.79,4.73,4.36-1.74-.32-3.72-1.88-5.07-4.23-1.48-2.56-1.78-5.3-.93-6.95Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "196.91 109.01 208.65 115.79 208.65 53.14 196.91 46.36 196.91 109.01"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "200.8 116.73 167.86 97.71 167.86 35.06 200.8 54.08 200.8 116.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "183.37 57.65 169.58 49.69 169.58 38.24 183.37 46.2 183.37 57.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "177.71 98.21 169.58 93.52 169.58 86.31 177.71 91.01 177.71 98.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "188.4 104.38 180.26 99.68 180.26 92.47 188.4 97.17 188.4 104.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 110.55 190.94 105.85 190.94 98.64 199.08 103.34 199.08 110.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 59.53 185.28 51.56 185.28 51.15 199.08 59.12 199.08 59.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 56.81 185.28 48.85 185.28 47.6 199.08 55.57 199.08 56.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 61.33 185.28 53.36 185.28 52.95 199.08 60.91 199.08 61.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 63.12 185.28 55.16 185.28 54.74 199.08 62.71 199.08 63.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 64.92 185.28 56.96 185.28 56.54 199.08 64.51 199.08 64.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 66.72 185.28 58.75 185.28 58.34 199.08 66.31 199.08 66.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 96.23 169.58 79.19 169.58 78.78 199.08 95.82 199.08 96.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 98.03 169.58 80.99 169.58 80.58 199.08 97.61 199.08 98.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.08 93.65 169.58 76.62 169.58 53.76 199.08 70.8 199.08 93.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.86 35.06 169.02 34.62 201.99 53.66 201.99 116.68 200.8 116.73 200.8 54.08 167.86 35.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "200.8 54.08 201.99 53.66 201.99 116.68 200.8 116.73 200.8 54.08"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "369.36 157.32 351.28 146.87 351.28 190.78 369.36 201.22 369.36 157.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "374.56 217.89 341.62 198.87 341.62 154.96 374.56 173.98 374.56 217.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 186.62 343.34 169.58 343.34 158.14 372.84 175.17 372.84 186.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 193 343.34 175.96 343.34 171.56 372.84 188.59 372.84 193"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 208.42 343.34 191.38 343.34 190.62 372.84 207.65 372.84 208.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 211.54 343.34 194.5 343.34 193.74 372.84 210.77 372.84 211.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 214.66 343.34 197.63 343.34 196.86 372.84 213.89 372.84 214.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "352.1 192.17 343.34 187.11 343.34 178.34 352.1 183.4 352.1 192.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 197.13 354.29 186.42 354.29 184.66 372.84 195.37 372.84 197.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 200.64 354.29 189.92 354.29 188.17 372.84 198.88 372.84 200.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.84 204.14 354.29 193.43 354.29 191.67 372.84 202.38 372.84 204.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "341.62 154.96 342.78 154.52 375.75 173.56 375.75 217.85 374.56 217.89 374.56 173.98 341.62 154.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "374.56 173.98 375.75 173.56 375.75 217.85 374.56 217.89 374.56 173.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M350.74,186.99c0,1.67-1.35,2.24-3.02,1.28-1.67-.96-3.02-3.09-3.02-4.76s1.35-2.24,3.02-1.28c1.67,.96,3.02,3.09,3.02,4.76Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "210.35 149.28 243.29 168.3 243.29 149.79 210.35 130.77 210.35 149.28"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "232.94 212.88 200 193.86 200 131.22 232.94 150.24 232.94 212.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "230.95 204.92 201.98 188.19 201.98 134.95 230.95 151.68 230.95 204.92"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "228.98 186.03 203.96 171.89 203.96 165.78 228.98 179.92 228.98 186.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "228.98 175.69 203.96 161.25 203.96 160.9 228.98 175.34 228.98 175.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "228.98 177.22 203.96 162.77 203.96 162.42 228.98 176.87 228.98 177.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "228.98 189.61 203.96 175.17 203.96 174.82 228.98 189.26 228.98 189.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "228.98 191.14 203.96 176.69 203.96 176.34 228.98 190.79 228.98 191.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "228.98 193.72 203.96 179.28 203.96 178.93 228.98 193.37 228.98 193.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "228.98 195.25 203.96 180.8 203.96 180.45 228.98 194.9 228.98 195.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "228.98 173.51 203.96 159.06 203.96 139.68 228.98 154.13 228.98 173.51"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "200 131.22 201.15 130.77 234.13 149.81 234.13 212.22 232.94 212.88 232.94 150.24 200 131.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "232.94 150.24 234.13 149.81 234.13 212.22 232.94 212.88 232.94 150.24"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "280.71 222.02 284.24 220.14 284.24 191.94 280.88 190 280.71 222.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "280.88 190 259.02 177.38 259.02 182.59 280.87 191.07 280.88 190"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "276.32 232.9 276.28 234.69 236.92 211.93 236.92 210.18 276.32 232.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "171.25 213.2 171.26 226.12 118.06 195.42 118.06 182.59 171.25 213.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "118.06 182.59 147.41 165.65 200.4 196.38 171.25 213.2 118.06 182.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M194.4,192.9l-40.96-23.75c-1.21,.15-2.42,.33-3.62,.56-15.47,2.88-24.01,10.94-21.14,19.01l24.39,14.04c7,1.12,14.68,1.13,21.97-.22,9.25-1.72,16.02-5.3,19.36-9.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "156.68 234.48 156.68 247.4 103.49 216.7 103.49 203.87 156.68 234.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "103.49 203.87 118.26 195.34 171.25 226.07 156.68 234.48 103.49 203.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "171.25 213.2 171.25 226.07 171.25 226.07 156.68 234.48 156.68 247.4 171.25 239.04 171.26 239.02 171.26 239.04 200.4 222.27 200.4 196.38 171.25 213.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.99,334.6c7.32,9.53-1.75,20.04-20.27,23.48-18.51,3.44-39.46-1.49-46.78-11.01-7.32-9.53,1.75-20.04,20.26-23.48,18.51-3.44,39.46,1.49,46.78,11.01Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 119.03,
    cy: 328.18,
    rx: 18.33,
    ry: 36.05,
    transform: "translate(-211.52 440.47) rotate(-88.83)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "109.17 63.17 108.93 62.76 173.96 25.22 199.2 39.79 198.96 40.2 173.96 25.77 109.17 63.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "109.17 66.99 108.93 66.57 173.96 29.03 199.2 43.6 198.96 44.02 173.96 29.58 109.17 66.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "109.17 70.8 108.93 70.39 173.96 32.84 199.2 47.42 198.96 47.83 173.96 33.39 109.17 70.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.41,184.17l6.91-3.65c4.19-.91,8.13-3.13,8.89-1.39,.84,1.93-.71,4.08-2.41,5.22-2.42,1.63-4.23,2.39-6.33,2.28l-.06,1.56-4.27,1.68-3.08-1.19v-1.14s.35-3.36,.35-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.12,196.64l.24,.54,5.01,.31,1.45-1.29s9.77-.39,10.69-5.06c1.03-5.25-8.79-1.28-9.81-1.28s-7.44,3.12-7.44,3.12l-.14,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M143.04,183.31l-1.63,.86-.36,3.36v1.14s3.09,1.19,3.09,1.19v-6.57s-.48,0-1.1,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M163.26,191.58c-1.59,.73-2.99,1.4-2.99,1.4l-.14,3.66,.24,.54,5.01,.31v-5.79l-2.12-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M147.81,55.28s0,0,0,0c3.27,1.64,6.06,.04,6.06,.04-.17-1.58,.29-3.38,1.72-3.44,1.14-.05,1.53,1.14,1.53,1.14,1.14-.88,1.21-1.8,1.4-2.9-.27-.49-1.04-1.08-2.59-1.1,0,0,1.04-.55,2.57-.04,1.78-1.1,2.65-1.99,3.08-2.66,0,0,0,0,.01,0,0,0,.16-.25,.37-.67,.24,2.68,.78,11.66-2.44,13.16-.84,.39-1.71,.35-2.55,.04-.33,1.31-.7,3.01-.81,4.52l-10.32-3.59s1.47-2.67,1.98-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M155.58,51.88c.39-.02,.69,.11,.92,.29-.04,0-1.43-.04-1.68,1.09-.25,1.14,.83,1.6,.72,2.31-.11,.71-1.2,.85-1.68-.25-.17-1.58,.29-3.38,1.72-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M162.71,43.2c-.03-.63-.3-1.11-.58-1.45,0,0,0,0,0,0h.02s-.33-1.54-2.68-1.94c-.83-.14-1.55,.06-2.15,.38-1.24-.58-2.37-.22-3.05,.12-.14-.04-.27-.08-.44-.11-1.69-.29-2.97,.83-3.56,1.49-.88,.27-1.89,.77-2.67,1.73-1.32,1.61-1.83,4.16-1.1,5.9-.07,.11-.14,.28-.21,.54-.41,1.6,.24,2.69,.89,3.34,.3,1.29,.62,2.1,.62,2.1,3.27,1.64,6.06,.04,6.06,.04-.17-1.58,.29-3.38,1.72-3.44,1.14-.05,1.53,1.14,1.53,1.14,.21-.16,.37-.32,.51-.48h0s1.78-1.62,.87-3.56c0,0,2.54,.26,2.89-2.38,.07-.09,.14-.18,.19-.27,0,0,0,0,.01,0,0,0,.76-.83,.88-2.29,.15-.18,.26-.44,.24-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M146.5,49.31c-.07,.11-.14,.28-.21,.54-.41,1.6,.24,2.69,.89,3.34,.3,1.29,.62,2.1,.62,2.1,3.27,1.64,6.06,.04,6.06,.04-.17-1.58,.29-3.38,1.72-3.44,.18,0,.33,.02,.47,.06,.66-2.32-.67-3.73-.67-3.73,0,0-2.9,.48-5.29-.91-2.38-1.39-2.5-3.89-2.5-3.89-1.32,1.61-1.83,4.16-1.1,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M153.86,55.33s-2.78,1.6-6.06-.04h0c-.51,1.83-1.97,4.49-1.97,4.49l6.48,2.26,1.13-4.37c1.79,.91,3.52,1.18,3.52,1.18-2.5-1.43-3.1-3.52-3.1-3.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "162.14 41.74 162.12 41.74 162.14 41.74 162.14 41.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M162.71,43.2c-.03-.63-.3-1.11-.58-1.45,0,0,0,0,0,0,0,0,.32,1.36-.47,2.15,0,0-.22,2.1-2.27,2.32,0,0-1.87,1.73-3.99,2,0,0,1.23,1.21,.67,3.73,.78,.23,1.06,1.08,1.06,1.08,.21-.16,.37-.32,.51-.48h0s1.78-1.62,.87-3.56c0,0,2.54,.26,2.89-2.38,.07-.09,.14-.18,.19-.27,0,0,0,0,.01,0,0,0,.76-.83,.88-2.29,.15-.18,.26-.44,.24-.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M198.1,63.6c-12.97,4.81-22.32,8.5-22.32,8.5-4.44-1.42-8.57-2.76-11.62-3.77,2.43-4.42,3.23-7.83,3.23-7.83l-2.79-2.08c-2.62,2.8-4.91,5.32-6.83,7.46-.39-.2-.79-.4-1.18-.59h0s-.45-1.93-.45-1.93c0,0-4.34-3.37-10.32-3.59,0,0-1.38,.74-2.26,2h.03c-1.31,.1-2.53,.39-3.63,.95-4.36,2.22-4.93,8.61-3.04,18.19,1.7,8.65,1.65,15.59,1.85,23.19,0,0,.14,8.37-.21,11.02,0,0,8.2,5.42,17.94,5.42,0,0,8.42,.03,13.58-5.6,0,0-.2-1.29-.49-3.24-.14-.93-1.61-12.7-1.61-12.7,0-.07-.01-.15-.02-.22h0c-.1-1.2-.22-2.47-.35-3.77-.11-3.2-.38-8.18-1.07-13.65,0-.78-.04-1.63-.12-2.52,7.27,1.33,10.94,.52,10.94,.52,12.48-3.48,22.63-12.42,22.63-12.42l-1.9-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M158.99,67.01c2.16,1.17,12.25,6.46,16.87,6.14,5.18-.36,22.63-8.81,22.65-8.82l-.41-.72c-12.97,4.81-22.32,8.5-22.32,8.5l-16.78-5.19-.02,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M140.06,116c2.8,1.54,9.19,4.54,16.44,4.54,0,0,7.59,.02,12.77-4.79,.81,7.38,1.54,18.52,.6,30.74-1.67,21.67-1.88,44.94-1.88,44.94l-7.71,1.64s-5.74-22.04-1.57-46.49c0,0-2.36-6.45-4.76-14.25-.16,2.6-.51,7.15-1.14,12.46-1.05,8.74-3.29,38.58-3.29,38.58l-8.15,1.37c-2.22-18.48,.54-40.56,.54-40.56,.14-1.39-.46-16.96-1.71-27.1-.05-.37-.08-.72-.12-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M139.97,62.73c1.1-.56,2.32-.85,3.63-.94h-.03c.88-1.27,2.26-2.01,2.26-2.01,.27,0,.53,.03,.79,.05-.1,.06-1,.66-.79,3.14,0,0-4.55,4.65-3.22,14.92,1.33,10.27,4.91,33.26,2.81,40.54-4.15-1.52-6.85-3.31-6.85-3.31,.35-2.64,.21-11.02,.21-11.02-.2-7.6-.14-14.53-1.85-23.19-1.89-9.58-1.32-15.97,3.04-18.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M140.06,116c.04,.36,.08,.7,.12,1.07,1.25,10.14,1.85,25.71,1.71,27.1,0,0-2.76,22.09-.54,40.56l2.65-.45h0c-2.03-12.91,1.4-40.38,1.4-40.38l1.2-16.49c1.4,1.27,4.92,2.9,4.92,2.9-4.29-3.93-6.12-11.89-6.12-11.89h0c-2.3-.84-4.15-1.77-5.35-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M153.95,132.33c2.4,7.81,4.76,14.25,4.76,14.25-4.17,24.45,1.57,46.49,1.57,46.49l4.11-.87c-3.44-14.17-1.89-45.67-1.89-45.67-.83-3.46-8.55-14.2-8.55-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M159.72,77.34s3.77,4.41,6.87,4.49c-.02-.16-.04-.31-.06-.47,0-.78-.04-1.63-.12-2.52-.03,0-4.96-1.03-6.7-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M159.72,77.34s2.17,3.53,4.67,5.33c0,0,1.33,5.54,1.27,12.75-.05,6.25-1.45,17.14-.58,23.11,1.75-.82,3.51-1.97,4.99-3.59,0,0-.2-1.29-.49-3.24-.14-.93-1.61-12.7-1.61-12.7,0-.07-.01-.15-.02-.22h0c-.1-1.2-.22-2.47-.35-3.77-.1-3.11-.37-7.89-1.01-13.17h0s-2.64,.22-6.87-4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M153.46,61.77l-.25,1.94s2.26,1.04,3.38,1.59l-.44-1.93s-1.35-1-2.69-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M167.86,145.31c-.51,8.54-1.69,35.81-1.12,46.39l1.26-.27s.21-23.27,1.88-44.94c.94-12.23,.21-23.36-.6-30.74-.98,.91-2.06,1.65-3.14,2.25,.27,2.11,2.26,18.36,1.73,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M147.74,183.66l1.77-.3s2.24-29.84,3.29-38.58c.64-5.31,.98-9.86,1.14-12.46,0,0-2.54-1.97-3.33-2.96,0,0,1.02,2.76,1.94,4.07,0,0-1.14,9.22-1.43,11.74-.25,2.1-3.26,26.02-3.37,38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M159.04,66.46c2.92-2.73,5.78-5.54,6.85-7.07l-1.29-.96s-3.33,3.57-6.83,7.46c.36,.17,.78,.36,1.27,.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M198.27,63.92l1.24-1.98s1.28-1.85,1.28-1.73v1.94l1.19-1.07,.36,1.22,.12,1.04-.2,2.11s-.88,1-2.37,1.33l-1.63-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M164.9,58.65l1-2.36,1.96-1.38v4.62s-.36,.63-.67,.83l-2.29-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M165.9,56.29s2.42-.54,2.5-.48c.08,.06-.38,1.03-1.25,1.41,0,0,.31,1.75-1.07,2.31l-1.18-.88s.42-1.42,1-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M167.15,57.22s.31,1.75-1.07,2.31l-.42-.31h0l.65,.48c.93-.14,1.55-1.27,1.55-1.27v-1.71h-.01c-.19,.2-.42,.38-.7,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M201.63,63.49l.72-1.19-.36-1.22-1.19,1.07-.43,.27,.43-1.34v-.86c0-.12-1.28,1.73-1.28,1.73l-1.24,1.98,.81,1.42,2.55-1.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "72.72 285.15 29.71 260.32 77.16 233.08 119.9 257.65 72.72 285.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "29.71 260.32 72.72 285.15 119.9 257.65 119.81 261 72.58 288.57 29.71 263.5 29.71 260.32"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "26.48 281.16 14.65 274.33 27.69 266.84 39.45 273.6 26.48 281.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "14.65 274.33 26.48 281.16 39.45 273.6 39.42 276.73 26.44 284.31 14.65 277.42 14.65 274.33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "43.15 291.33 31.32 284.5 44.37 277.02 56.12 283.77 43.15 291.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "31.32 284.5 43.15 291.33 56.12 283.77 56.09 286.9 43.11 294.48 31.32 287.59 31.32 284.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "41.29 256.63 75.41 236.77 107.03 254.85 73.32 274.47 41.29 256.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "41.29 256.66 41.29 259.94 73.32 278.43 73.32 274.5 41.29 256.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.32 274.5 107.03 254.88 107.03 259.21 73.32 278.43 73.32 274.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "100.76 254.06 71.4 270.7 47.55 257.19 76.92 240.54 100.76 254.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.56 251.93 82.5 257.63 81.7 257.18 91.76 251.48 92.56 251.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "88.39 249.57 78.33 255.27 68.35 249.61 78.41 243.91 88.39 249.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.37 253.53 85.31 259.23 84.52 258.78 94.58 253.08 95.37 253.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M68.06,257.69c.84-1.11,.42-2.48-1.24-3.42-2.15-1.22-5.57-1.26-7.63-.09-2.06,1.17-1.99,3.1,.16,4.32,1.66,.94,4.07,1.18,6.03,.7-2.24,2-1.73,4.74,1.47,6.55l3.47,1.97,12.77-7.24-3.47-1.97c-3.2-1.81-8.04-2.1-11.56-.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "41.29 248.62 75.41 228.76 107.03 246.84 73.32 266.46 41.29 248.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "41.29 248.65 41.29 251.92 73.32 270.42 73.32 266.49 41.29 248.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.32 266.49 107.03 246.87 107.03 251.2 73.32 270.42 73.32 266.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "100.76 246.04 71.4 262.69 47.55 249.17 76.92 232.53 100.76 246.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.56 243.92 82.5 249.62 81.7 249.17 91.76 243.47 92.56 243.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "88.39 241.55 78.33 247.25 68.35 241.6 78.41 235.9 88.39 241.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.37 245.51 85.31 251.21 84.52 250.76 94.58 245.06 95.37 245.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M68.06,249.67c.84-1.11,.42-2.48-1.24-3.42-2.15-1.22-5.57-1.26-7.63-.09s-1.99,3.1,.16,4.32c1.66,.94,4.07,1.18,6.03,.7-2.24,2-1.73,4.74,1.47,6.55l3.47,1.97,12.77-7.24-3.47-1.97c-3.2-1.81-8.04-2.1-11.56-.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "41.29 240.6 75.41 220.75 107.03 238.82 73.32 258.44 41.29 240.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "41.29 240.64 41.29 243.91 73.32 262.4 73.32 258.48 41.29 240.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.32 258.48 107.03 238.86 107.03 243.19 73.32 262.4 73.32 258.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "100.76 238.03 71.4 254.67 47.55 241.16 76.92 224.52 100.76 238.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.56 235.9 82.5 241.6 81.7 241.15 91.76 235.45 92.56 235.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "88.39 233.54 78.33 239.24 68.35 233.59 78.41 227.89 88.39 233.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.37 237.5 85.31 243.2 84.52 242.75 94.58 237.05 95.37 237.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M68.06,241.66c.84-1.11,.42-2.48-1.24-3.42-2.15-1.22-5.57-1.26-7.63-.09-2.06,1.17-1.99,3.1,.16,4.32,1.66,.94,4.07,1.18,6.03,.7-2.24,2-1.73,4.74,1.47,6.55l3.47,1.97,12.77-7.24-3.47-1.97c-3.2-1.81-8.04-2.1-11.56-.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "41.29 232.59 75.41 212.74 107.03 230.81 73.32 250.43 41.29 232.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "41.29 232.62 41.29 235.9 73.32 254.39 73.32 250.46 41.29 232.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.32 250.46 107.03 230.84 107.03 235.18 73.32 254.39 73.32 250.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "100.76 230.02 71.4 246.66 47.55 233.15 76.92 216.51 100.76 230.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.56 227.89 82.5 233.59 81.7 233.14 91.76 227.44 92.56 227.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "88.39 225.53 78.33 231.23 68.35 225.57 78.41 219.87 88.39 225.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.37 229.49 85.31 235.19 84.52 234.74 94.58 229.04 95.37 229.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M68.06,233.65c.84-1.11,.42-2.48-1.24-3.42-2.15-1.22-5.57-1.26-7.63-.09s-1.99,3.1,.16,4.32c1.66,.94,4.07,1.18,6.03,.7-2.24,2-1.73,4.74,1.47,6.55l3.47,1.97,12.77-7.24-3.47-1.97c-3.2-1.81-8.04-2.1-11.56-.83Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "336.95 277.39 373.62 256.22 333.17 233.01 296.73 253.96 336.95 277.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "336.71 274.49 368.58 256.09 333.43 235.91 301.76 254.12 336.71 274.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "373.62 256.22 336.95 277.39 296.73 253.96 296.8 256.81 337.06 280.31 373.62 258.94 373.62 256.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "301.76 254.12 311.03 248.79 326.9 247.3 328.26 255.2 348.86 255.2 350.86 266.32 336.71 274.49 301.76 254.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "373.62 256.22 336.95 277.39 337.06 280.31 373.62 258.94 373.62 256.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "228.83 303.92 301.81 261.79 221.3 215.58 148.78 257.27 228.83 303.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "301.81 261.79 228.83 303.92 148.78 257.27 148.93 262.95 229.06 309.74 301.81 267.2 301.81 261.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "228.83 303.92 229.06 309.74 148.93 262.95 148.78 257.27 228.83 303.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "29.66 160.93 111.63 113.6 111.63 40.86 29.66 88.19 29.66 160.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "34.69 116.5 107.1 74.69 107.1 49.71 34.69 91.52 34.69 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "82.12 124.4 107.1 109.98 107.1 85 82.12 99.42 82.12 124.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "34.69 151.79 79.44 125.95 79.44 100.97 34.69 126.8 34.69 151.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "34.69 121.98 107.1 80.18 107.1 78.67 34.69 120.47 34.69 121.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "36.78 128.56 77.35 105.14 77.35 104.71 36.78 128.13 36.78 128.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "36.78 132.16 77.35 108.73 77.35 108.3 36.78 131.73 36.78 132.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "36.78 135.75 77.35 112.33 77.35 111.9 36.78 135.32 36.78 135.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "36.78 139.34 77.35 115.92 77.35 115.49 36.78 138.91 36.78 139.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "36.78 142.94 77.35 119.51 77.35 119.08 36.78 142.51 36.78 142.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "36.78 146.53 77.35 123.11 77.35 122.68 36.78 146.1 36.78 146.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.66 88.19 111.63 40.86 111.63 36.61 29.66 83.94 29.66 88.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M86.17,109.57c0,4.66,3.78,6.26,8.44,3.57s8.44-8.65,8.44-13.31-3.78-6.26-8.44-3.57-8.44,8.65-8.44,13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.87,108.83c-.29,3.17,2.05,4.02,5.22,1.9,3.17-2.12,5.97-6.4,6.26-9.57,.29-3.17-2.05-4.02-5.22-1.9-3.17,2.12-5.97,6.4-6.26,9.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M364.38,199.31l3.89-3.45c-.03-.17-2.29,.67-2.29,.67,0,0,2.31-1.88,2.32-2.03,.01-.15-2.74,1.06-2.97,1.21-.24,.15,2.28-2.01,2.3-2.12,.03-.11-2.92,1.2-2.92,1.2,0,0,1.11-2.97,1.07-3.12-.05-.15-1.48,1.99-1.8,2.42,0,0-1.68,2.4-2.06,3.13-.53,1.01,1.62,2.55,2.47,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M364.71,194.79s1.11-2.97,1.07-3.12c-.05-.15-1.48,1.99-1.8,2.42,0,0-1.68,2.4-2.06,3.13-.31,.6,.32,1.39,1.07,1.83,.17,.02,.28,.03,.28,.03l1.44-3.28c-.22-.44,0-1.01,0-1.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M319.13,210.02s0,0,0,0c3.27,1.64,6.06,.04,6.06,.04-.17-1.58,.29-3.38,1.72-3.44,1.14-.05,1.53,1.14,1.53,1.14,1.14-.88,1.21-1.8,1.4-2.9-.27-.49-1.04-1.08-2.59-1.1,0,0,1.04-.55,2.57-.04,1.78-1.1,2.65-1.99,3.08-2.66,0,0,0,0,.01,0,0,0,.06-.66,.27-1.09,.24,2.68,.88,12.07-2.34,13.57-.84,.39-1.71,.35-2.55,.04-.33,1.31-.7,3.01-.81,4.52l-10.32-3.59s1.47-2.67,1.98-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M318.56,201.47s.72-2.81,2.91-4.1c1.79-1.06,6.78-1.18,6.78-1.18,6.84,.36,4.66,4.89,4.66,4.89,0,0,0,0-.01,0-.43,.67-1.3,1.55-3.08,2.66,.39,1.94-.24,3.17-1.38,4.04,0,0-.39-1.19-1.53-1.14-1.43,.07-1.89,1.86-1.72,3.44,0,0-2.78,1.6-6.06-.04,0,0-1.16-3.8-.57-8.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M326.9,206.63c.39-.02,.69,.11,.92,.29-.04,0-1.43-.04-1.68,1.09-.25,1.14,.83,1.6,.72,2.31-.11,.71-1.2,.85-1.68-.25-.17-1.58,.29-3.38,1.72-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M328.71,203.7c.42-.26,.75-.95,.75-.95-4.63,3.34-8.72-.18-8.72-.18-1,.06-1.71-.69-2.12-1.32-.04,.14-.07,.22-.07,.22-.6,4.76,.57,8.56,.57,8.56,3.27,1.64,6.06,.04,6.06,.04-.17-1.58,.29-3.38,1.72-3.44,1.11-.05,1.51,1.06,1.53,1.13,1.12-2.09,.28-4.06,.28-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M325.55,209.72l-.39,.05c0,.1,0,.21,.02,.31,0,0-2.78,1.6-6.06-.04,0,0,0,0,0,0-.51,1.83-1.98,4.5-1.98,4.5l5.3,1.84,.92-2.75,1.9-1.19c1.15,.72,3.01,1.17,3.01,1.17-1.64-1.09-2.73-3.87-2.73-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M331.87,197.11c.16,1.27,.1,3.58-2.08,5.24,0,0,2.68-.96,3.34-3.63-.16-.57-.53-1.15-1.26-1.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M361.69,197.37c-8.11,12.39-15.3,21-15.3,21-8.88,1.93-16.06,1.83-18.38,1.73-.03-.02-.07-.03-.1-.05h0s-.45-1.93-.45-1.93c0,0-4.34-3.37-10.32-3.59,0,0-1.38,.74-2.26,2h.03c-1.31,.1-2.53,.39-3.63,.95-4.36,2.22-4.93,8.61-3.04,18.19,1.7,8.65,1.65,15.59,1.85,23.19,0,0,.14,8.37-.21,11.02,0,0,8.11,3.31,17.86,3.31,0,0,7.75,.8,13.66-3.49,0,0-.2-1.29-.49-3.24-.14-.93-1.61-12.7-1.61-12.7,0-.07-.01-.15-.02-.22h0c-.1-1.2-.22-2.47-.35-3.77-.11-3.2-.38-8.18-1.07-13.65-.01-.82-.04-1.71-.13-2.65-.1-1.25-.35-2.43-.66-3.48,11.05-2.37,14.63-6.06,14.63-6.06,7.97-9.55,13.25-24.87,13.25-24.87l-3.26-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M312.73,338.92l6.91-3.65c4.19-.91,8.13-3.13,8.89-1.39,.84,1.93-.71,4.08-2.41,5.22-2.42,1.63-4.23,2.39-6.33,2.28l-.06,1.56-4.27,1.68-3.08-1.19v-1.14s.35-3.36,.35-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.44,351.39l.24,.54,5.01,.31,1.45-1.29s9.77-.39,10.69-5.06c1.03-5.25-8.79-1.28-9.81-1.28s-7.44,3.12-7.44,3.12l-.14,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M311.17,270.22c2.8,1.54,10.01,2.66,16.57,2.93,0,0,7.6,.54,12.83-2.93,.81,7.38,1.56,18.76,.62,30.99-1.67,21.67-1.88,44.94-1.88,44.94l-7.71,1.64s-5.74-22.04-1.57-46.49c0,0-2.36-6.45-4.76-14.25-.16,2.6-.51,7.15-1.14,12.46-1.05,8.74-3.29,38.58-3.29,38.58l-8.15,1.37c-2.22-18.48,.54-40.56,.54-40.56,.14-1.39-.46-16.96-1.71-27.1-.05-.37-.3-1.22-.34-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M332.93,230.74s2.2,1.75,4.71,1.84c-.13-.93-.33-1.8-.57-2.6-.03,0-3.01,.73-4.14,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.51,271.82c1.25,10.14,1.85,25.71,1.71,27.1,0,0-2.76,22.09-.54,40.56l4.01-.67c-.92-10.04,.6-36.35,1.25-40.27,.69-4.17,0-16.69,0-16.69,2.48,1.55,4.32,2.03,4.32,2.03-5.72-4.53-6.8-11.19-6.8-11.19l.03-1.03c-1.94-.6-3.09-.84-4.22-1.28,.04,.36,.19,1.08,.24,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.6,347.82l3.57-.76c-3.98-15.56-.76-45.19-.88-45.9-.12-.72-1.45-2.3-4.08-7.07-2.62-4.77-4.95-7.01-4.95-7.01,2.4,7.81,4.76,14.25,4.76,14.25-4.17,24.45,1.57,46.49,1.57,46.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.47,221.4c4.9-.3,7.28-1.42,8.06-2.05l14.92-21.59-.76-.39c-8.11,12.39-15.3,21-15.3,21-10.86,2.36-19.18,1.68-19.18,1.68,0,0,7.36,1.65,12.25,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M333.9,253.55c-8.3,1.99-14.53,.11-17.25-1.02-.86-7.37-2.08-14.96-2.72-19.9-.85-6.57,.7-10.83,1.94-13.06,4.43,.71,10.45,.36,10.45,.36-4.69-.83-9.16-2.22-9.16-2.22-.22-2.48,.69-3.08,.79-3.14-.26-.02-.52-.04-.79-.05,0,0-1.38,.74-2.26,2h.03c-1.31,.1-2.53,.39-3.63,.95-1.67,.85-2.78,2.31-3.41,4.32-3.54,9.79-3.37,14.84-3.37,14.84,1.11,5.73,3.31,11.17,5.41,15.44,.07,2.24,.11,4.48,.17,6.78,0,0,.14,8.37-.21,11.02,0,0,2.7,1.13,7.13,2.09,.75-2.61,.74-7.08,.35-12.21l.89-.4c-.34-1.34-.68-2.63-1.01-3.88,8.51,2.36,16.66-1.91,16.66-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M323.93,216.12s.38,2.6,.74,3.5c0,0,1.47,.5,3.25,.43l-.45-1.94s-1.59-1.26-3.54-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.9,266.44c-.14-.93-1.61-12.7-1.61-12.7,0-.07-.01-.15-.02-.22h0c-.1-1.2-.22-2.47-.35-3.77-.11-3.2-.38-8.18-1.07-13.65-.01-.82-.04-1.71-.13-2.65-.02-.3-.05-.59-.09-.87h0s-1.53,.23-4.71-1.84c0,0,1.17,2.24,3.35,6.68,0,0,1.31,9.64,1.36,12.68,.05,3.04-.94,17.35,0,21.62,1.28-.5,2.56-1.16,3.76-2.04,0,0-.2-1.29-.49-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M340.61,270.22c-.97,.62-1.97,1.11-2.97,1.5,0,0,2.82,15.52,2.55,22.68-.25,6.65-2.54,42.25-2.03,51.99l1.16-.25s.21-23.62,1.88-45.29c.93-12.04,.22-23.25-.58-30.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M324.12,299.51c.64-5.29,.98-9.83,1.14-12.43-.02-.01-2.57-2.21-3.01-3.2,0,0,.67,2.53,1.51,4.79,0,0-.35,5.97-.57,7.9-.22,1.93-3.55,38.61-3.47,41.71l1.12-.19s2.24-29.84,3.29-38.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "315.46 344.61 315.94 338.93 312.68 339.48 312.37 342.28 312.38 343.42 315.46 344.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "338.15 350.94 337.05 349.8 336.9 346.66 331.6 347.82 331.44 351.39 331.69 351.92 336.7 352.23 338.15 350.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M347.95,343.5c.04,.71-.19,1.79-1.45,3.02-2.08,2.05-9.45,3.28-9.45,3.28l-.56,.59,.2,1.84,1.45-1.29s9.77-.39,10.69-5.06c.25-1.28-.14-2.01-.9-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M319.79,341.37c2.1,.12,3.91-.65,6.33-2.28,1.65-1.11,3.16-3.17,2.47-5.06-1.85,5.86-10.34,6.38-10.34,6.38l.63,1-3.25,1.11-.18,2.07,4.27-1.68,.06-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "101.56 224.61 81.71 190.27 113.51 171.83 133.56 205.88 101.56 224.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "113.51 171.83 112.17 171.83 80.62 190.04 100.44 224.25 101.56 224.61 81.71 190.27 113.51 171.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "80.62 190.04 81.71 190.27 101.56 224.61 100.44 224.25 80.62 190.04"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M143.29,328.18l-6.91-3.65c-4.19-.91-8.13-3.13-8.89-1.39-.84,1.93,.71,4.08,2.41,5.22,2.42,1.63,4.23,2.39,6.33,2.28l.06,1.56,4.27,1.67,3.08-1.19v-1.14s-.35-3.36-.35-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M136.22,330.64l.06,1.56,4.27,1.67,3.08-1.19v-1.14s-.35-3.36-.35-3.36l-.48-.26-4.81,.88-.67-.62c-6.64-.62-8.67-3.84-9.29-5.58-.25,.1-.44,.27-.56,.54-.84,1.93,.71,4.08,2.41,5.22,2.42,1.63,4.23,2.39,6.33,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M124.57,340.65l-.24,.54-5.01,.31-1.45-1.29s-9.77-.39-10.69-5.06c-1.03-5.25,8.79-1.28,9.81-1.28s7.44,3.12,7.44,3.12l.14,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M119.31,341.5l5.01-.31,.24-.54-.14-3.66s-2.42-1.18-4.53-2.09l-.36,3.74-1.78-.81c-8.48-.14-10.18-4.54-10.22-4.66-.38,.42-.54,1.06-.36,1.98,.92,4.67,10.69,5.06,10.69,5.06l1.45,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M144.63,260.01c-2.8,1.54-9.19,4.54-16.44,4.54,0,0-7.59,.02-12.77-4.79-.81,7.38-1.54,18.52-.6,30.74,1.67,21.67,1.88,44.94,1.88,44.94l7.71,1.64s5.74-22.04,1.57-46.49c0,0,2.36-6.45,4.76-14.25,.16,2.6,.51,7.15,1.14,12.46,1.05,8.74,3.29,38.58,3.29,38.58l8.15,1.37c2.22-18.48-.54-40.56-.54-40.56-.14-1.39,.46-16.96,1.71-27.1,.05-.37,.08-.72,.12-1.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M130.85,199.13s-.58,2.35-2.67,3.86-4.66-.56-5.36-3.91c-.7-3.35-1.1-5.64-1.14-8.61-.07-4.37,6.45-5.35,9.66-3.57,3.53,1.97,.56,10.77-.49,12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M131.35,186.91s4.21,1.53,5.15,5.88c.79,3.67,0,4.47,.43,6.5,0,0,.69,2.22,1.98,4.49,0,0-8.77,3.11-10.32,3.59,0,0-.24-2.2-.81-4.52l3.58-15.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M130.75,276.34c2.91-4.02,5.29-10.81,5.29-10.81-.32,4.23-3.04,10.58-3.04,10.58,.44,1.23,2.03,5.16,2.91,12.65,.75,6.4,2.86,39.22,2.86,39.22l-3.59-.6s-2.24-29.84-3.29-38.58c-.64-5.31-.98-9.85-1.14-12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M115.42,259.76s2.2,1.62,4.72,3.02c0,0-2.3,19.5-2.04,27.08,.26,7.58,2.86,40.98,2.04,46.31l-3.43-.73s-.21-23.27-1.88-44.94c-.94-12.22-.22-23.36,.6-30.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M116.72,243c0-.07,.01-.15,.02-.22h0c.1-1.2,.22-2.47,.35-3.77,.11-3.2,.38-8.18,1.07-13.65,.01-.82,.04-1.71,.13-2.65,.36-4.65,2.82-8.25,2.82-8.25,1.09-1.5,2.59-2.86,4.64-3.96,.78-.42,1.56-.82,2.35-1.2h0s.45-1.93,.45-1.93c0,0,4.34-3.37,10.32-3.59,0,0,1.38,.74,2.26,2h-.03c1.31,.1,2.53,.39,3.63,.95,4.36,2.22,4.93,8.61,3.04,18.19-1.7,8.65-1.65,15.59-1.85,23.19,0,0-.14,8.37,.21,11.02,0,0-8.2,5.42-17.94,5.42,0,0-8.42,.03-13.58-5.6,0,0,.2-1.29,.49-3.24,.14-.93,1.61-12.7,1.61-12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.61,197.6s-.13-4.34-2.26-7.85c.42-.52,.67-1.17,.67-1.89,0-1.66-1.34-3-3-3-.96,0-1.82,.46-2.37,1.16-2.13-.71-5.3-1.18-7.91,.89-2.37,1.89-1.07,4.94-1.07,4.94,0,0,2.86,4.67,7.37,5.29,0,0-1.26,4.41-2.17,8.52l2.49,.95s8.23-.61,10.94-3.34c0,0-1.95-3.33-2.69-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M128.4,220.75s-7.03,2.32-7.63,3.1c-.25,.33-1.43,1.31-2.71,2.32-.61,5.15-.87,9.8-.97,12.84-.12,1.29-.24,2.57-.35,3.77h0c0,.07-.01,.15-.02,.22,0,0-1.48,11.77-1.61,12.7-.29,1.95-.49,3.24-.49,3.24,2.62,2.86,6.09,4.26,8.86,4.94,2.58-9.02-1.29-30.33-1.29-30.33,6.54-5.24,6.21-12.81,6.21-12.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M129.45,216.35h0s0-.06,0-.09h0c-.06-2.65-1.39-4.32-3.43-4.52-2.06-.2-3.82,1.42-3.83,1.43-.54,.37-1.09,.86-1.62,1.47-4.9,5.71-10.51,13.65-10.51,13.65-1.55-3.26-16.06-15.53-16.06-15.53l-.81-1.02-.43-.74c.08-.84-.16-1.89-.21-1.97-.02-.04-.25,.29-.52,.71l-.71-1.23s-1.12,2.63-1.25,3.19c-.04,.17,1.26,3.19,1.26,3.19,0,0,13.26,24.35,22.18,20.55,2.47-1.05,4.88-3.03,7.08-5.37,5.64,1.13,8.71-12.51,8.71-12.51,0,0,0,0,0,0,.11-.4,.16-.81,.15-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M128.87,218.6c-1.87,3.25-4.82,7.79-8.26,11.45,.43,.08,.85,.11,1.25,.03,1.27-.5,4.36-5.36,7.15-11.37,.07-.16,.09-.32,.12-.46,.06-.24,.13-.47,.17-.7,0,0,0,0,0,0-.1,.35-.23,.7-.43,1.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M134.17,205.9c-2.07,.45-3.94,.65-4.56,.7-.73,.45-1.06,.78-1.06,.78l-.44,1.93c-3.82,1.5-5.91,3.87-5.91,3.87,4.16-3.22,6.38,.03,6.38,.03,1-1.46,1.46-4.38,1.46-4.38,1.92-.48,4.58-1.45,4.58-1.45l-.43-1.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M113.51,235.44c2.3-.98,4.54-2.77,6.61-4.89-2.58,1.85-7.21,5.08-12.23,2.53-5.05-2.56-15.86-18.75-15.86-18.75l-1.96-2.62c-.04,.17,1.26,3.19,1.26,3.19,0,0,13.26,24.35,22.18,20.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M126.9,196.7l-.32-.34c-2.75-1.36-4.51-3.92-4.84-4.42,.01,.25,.03,.49,.05,.73,0,.01,2.7,4.18,5.08,4.92,0,0-.17-.24,.04-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M130.02,187.86c0,1.66,1.34,3,3,3,.91,0,1.71-.41,2.26-1.05-3.1-.45-2.79-3.23-2.79-3.23-.37,.64-.37,1.71-.37,1.71-.63-1.55,.89-3.43,.89-3.43-1.66,0-3,1.34-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M129.37,206.62s.99-.08,2.38-.28c-.13-2.13-.1-6.04,.12-8.36,.27-2.92-2.21-5.25-4.32-5.39-2.12-.15-2.86-.8-2.86-.8,.98,1.19,2.19,1.73,2.19,1.73-4.24-.83-5.46-4.26-5.47-4.32-.25,1.4,.29,2.67,.29,2.67,0,0,2.86,4.67,7.37,5.29,0,0-1.26,4.41-2.17,8.52l2.49,.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M126.9,196.7s.12-1.49,1.51-1.17c1.06,.24,1.09,2.07,.84,2.81-.25,.74-.96,1.56-1.71,1.33-.65-.2-.55-.88-.47-1.11,0,0-.3-.72-.16-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M127.35,197.44s.23-1.23,.77-1.29,.88,1.97,0,2.46c-.87,.5-.49-1.09-.36-1.31,.14-.22-.22-.14-.42,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M117.91,339.55c-9.93-.24-10.8-5.34-10.8-5.37-.03,.28-.01,.6,.06,.97,.92,4.67,10.69,5.06,10.69,5.06l1.45,1.29,5.01-.31,.24-.54-5.05,.15-1.61-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M143.64,331.8h0l-3.19,1.19-3.46-1.31v-1.67h-.54c-7.93-.6-9.15-6.27-9.15-6.28-.34,1.77,1.06,3.6,2.59,4.63,2.42,1.63,4.23,2.39,6.33,2.28l.06,1.56,4.27,1.67,3.08-1.19v-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M147.55,226.07s-4,10.59-4.84,11.79c-.83,1.19,3.57-1.08,3.57-1.08h0c.2-3.38,.58-6.89,1.27-10.7h-.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M141.11,205.76l-.02,.03h.03s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M145.92,248.11c.2-7.6,.14-14.53,1.85-23.19,1.89-9.58,1.32-15.97-3.04-18.19-1.1-.56-2.32-.85-3.63-.94,0,0,4.54,2.4,5.33,9.78,.79,7.39-4.84,40.58-4.3,45.69,2.49-1.14,4.01-2.14,4.01-2.14-.35-2.64-.21-11.02-.21-11.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M141.08,205.73c-.57-.79-1.31-1.36-1.78-1.67-.41,.26-.87,.49-1.37,.7,.76,.7,1.6,1.54,1.6,1.54l1.56-.51v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M143.33,328.75c2.22-18.48-.54-40.56-.54-40.56-.14-1.39,.46-16.96,1.71-27.1,.05-.37,.08-.72,.12-1.07-.65,.36-1.5,.79-2.5,1.25,0,0-1.23,22.41-1.04,26.46,.19,3.91,3.08,30.49,.78,40.78l1.46,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M130.78,276.81c-.01-.16-.02-.32-.03-.47,1.07-1.49,2.08-3.35,2.91-5.11l2.38-5.71s-4.47,7.97-6.53,9.94c0,0-4.15,12.55-4.94,14.82,0,0,2.93,20.32-1.28,46.55l1.12,.24s5.74-22.04,1.57-46.49c0,0,2.36-6.45,4.76-14.25,0,.15,.02,.31,.03,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M137.61,197.6s-.13-4.33-2.26-7.84c-.02,.02-.05,.03-.07,.05,0,0,1.51,2.8,1.57,6.15,.05,2.69,.67,6.62,1.45,8.64,.8-.37,1.49-.81,1.99-1.31,0,0-1.95-3.33-2.69-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M133.02,184.86c-.12,0-.24,0-.36,.02,.04,0,2.72,.44,2.82,4.69,.34-.49,.54-1.08,.54-1.71,0-1.66-1.34-3-3-3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M107.26,194.02c1.49-1.81,1.79-4.45,.55-6.63-1.59-2.81-5.12-3.8-7.87-2.21s-3.69,5.14-2.1,7.95c1.24,2.19,3.65,3.26,5.96,2.89-2.97,2.77-3.75,7.36-1.63,11.1l3.86,6.79,15.42-8.88-3.86-6.79c-2.12-3.74-6.45-5.38-10.33-4.22Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "111.63 36.61 108.9 35.97 27.05 82.91 27.05 159.84 29.66 160.93 29.66 83.94 111.63 36.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "27.05 82.91 29.66 83.94 29.66 160.93 27.05 159.84 27.05 82.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M234.53,257.87v-3.51l-1.46,.49-.72-1.49-7.66,.06c-1.14-1.14-2.54-2.16-4.14-3.05l1.96-4.28v-3.51l-1.4,3.05-2.13-.7-3.53-1.16-5.33,3.18c-2.14-.34-4.37-.51-6.63-.49l-3.86-3.84-3.9,.62-3.9,.62,.13,4.43c-1.96,.65-3.72,1.45-5.26,2.37l-7.42-1.16-1.76,1.8-2.22-1.24v3.51l5.52,3.1c-.57,1.24-.86,2.53-.81,3.84l-5.16,1.72-1.46-3.03v3.51l1.09,2.26,1.09,2.26,7.65-.06c1.14,1.14,2.54,2.17,4.14,3.06l-.56,1.22-1.4-.46v3.51l3.53,1.16,3.53,1.16,5.32-3.17c2.15,.34,4.38,.51,6.66,.49l3.84,3.83,3.9-.62,3.9-.62v-3.51l-.11,.02-.03-.92c1.97-.65,3.74-1.46,5.28-2.38l7.4,1.15,1.99-2.03,1.99-2.03v-3.51l-2.22,2.27-3.29-1.85c.57-1.24,.86-2.53,.81-3.85l6.61-2.21Zm-26.96,9.88c-7.12,1.13-14.51-1.3-16.49-5.43s2.17-8.38,9.29-9.51c7.12-1.13,14.51,1.3,16.49,5.43,1.99,4.13-2.17,8.38-9.29,9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M198.33,260.15s0,.05,0,.08v.13h0c.01,.26,.07,.52,.2,.78,.84,1.74,3.95,2.76,6.95,2.29,2.46-.39,4.07-1.66,4.12-3.06h0v-3.6h-11.28v3.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M224.69,249.89c-1.14-1.14-2.54-2.16-4.14-3.05l1.96-4.28-3.53-1.16-3.53-1.16-5.33,3.18c-2.14-.34-4.37-.51-6.63-.49l-3.86-3.84-3.9,.62-3.9,.62,.13,4.43c-1.96,.65-3.72,1.45-5.26,2.37l-7.42-1.16-1.99,2.03-1.99,2.03,5.52,3.1c-.57,1.24-.86,2.53-.81,3.84l-6.62,2.21,1.09,2.26,1.09,2.26,7.65-.06c1.14,1.14,2.54,2.17,4.14,3.06l-1.96,4.28,3.53,1.16,3.53,1.16,5.31-3.17c2.15,.34,4.38,.51,6.66,.49l3.84,3.83,3.9-.62,3.9-.62-.13-4.42c1.97-.65,3.74-1.46,5.28-2.38l7.4,1.15,1.99-2.03,1.99-2.03-5.51-3.09c.57-1.24,.86-2.53,.81-3.85l6.61-2.21-1.09-2.26-1.09-2.26-7.66,.05Zm-17.12,14.34c-7.12,1.13-14.51-1.3-16.49-5.43s2.17-8.38,9.29-9.51c7.12-1.13,14.51,1.3,16.49,5.43,1.99,4.13-2.17,8.38-9.29,9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M209.41,255.9c.84,1.74-.92,3.53-3.92,4.01-3,.48-6.11-.55-6.95-2.29s.92-3.53,3.92-4.01c3-.48,6.11,.55,6.95,2.29Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M277.93,258.56v-2.5l-1.04,.35-.51-1.06-5.44,.04c-.81-.81-1.8-1.54-2.94-2.17l1.39-3.04v-2.5l-.99,2.17-1.51-.5-2.5-.82-3.78,2.26c-1.52-.24-3.1-.36-4.71-.35l-2.74-2.73-2.77,.44-2.77,.44,.1,3.15c-1.39,.46-2.64,1.03-3.73,1.68l-5.27-.82-1.25,1.28-1.57-.88v2.5l3.92,2.2c-.41,.88-.61,1.79-.58,2.73l-3.66,1.22-1.04-2.15v2.5l.77,1.6,.77,1.6,5.43-.04c.81,.81,1.8,1.54,2.94,2.17l-.4,.87-.99-.33v2.5l2.5,.82,2.5,.82,3.77-2.25c1.52,.24,3.11,.36,4.73,.35l2.73,2.72,2.77-.44,2.77-.44v-2.5h-.08s-.02-.64-.02-.64c1.4-.46,2.66-1.04,3.75-1.69l5.25,.82,1.41-1.44,1.41-1.44v-2.5l-1.57,1.61-2.34-1.31c.41-.88,.61-1.8,.57-2.73l4.7-1.57Zm-19.14,7.02c-5.06,.8-10.3-.92-11.71-3.85-1.41-2.93,1.54-5.95,6.6-6.76,5.06-.8,10.3,.92,11.71,3.85,1.41,2.93-1.54,5.95-6.6,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M252.22,260.18s0,.04,0,.06v.1h0c.01,.18,.05,.37,.14,.55,.6,1.23,2.81,1.96,4.94,1.62,1.74-.28,2.89-1.18,2.93-2.18h0v-2.56h-8.01v2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M270.94,252.89c-.81-.81-1.8-1.54-2.94-2.17l1.39-3.04-2.5-.82-2.5-.82-3.78,2.26c-1.52-.24-3.1-.36-4.71-.35l-2.74-2.73-2.77,.44-2.77,.44,.1,3.15c-1.39,.46-2.64,1.03-3.73,1.68l-5.27-.82-1.41,1.44-1.41,1.44,3.92,2.2c-.41,.88-.61,1.79-.58,2.73l-4.7,1.57,.77,1.6,.77,1.6,5.43-.04c.81,.81,1.8,1.54,2.94,2.17l-1.39,3.04,2.5,.82,2.5,.82,3.77-2.25c1.52,.24,3.11,.36,4.73,.35l2.73,2.72,2.77-.44,2.77-.44-.1-3.14c1.4-.46,2.66-1.04,3.75-1.69l5.25,.82,1.41-1.44,1.41-1.44-3.91-2.2c.41-.88,.61-1.8,.57-2.73l4.7-1.57-.77-1.6-.77-1.6-5.44,.04Zm-12.16,10.19c-5.06,.8-10.3-.92-11.71-3.85-1.41-2.93,1.54-5.95,6.6-6.76,5.06-.8,10.3,.92,11.71,3.85,1.41,2.93-1.54,5.95-6.6,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M260.09,257.16c.6,1.23-.65,2.51-2.78,2.85s-4.34-.39-4.94-1.62c-.6-1.23,.65-2.51,2.78-2.85,2.13-.34,4.34,.39,4.94,1.62Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M250.54,237.88v-1.48l-.62,.21-.3-.63-3.23,.02c-.48-.48-1.07-.91-1.75-1.29l.83-1.81v-1.48l-.59,1.29-.9-.3-1.49-.49-2.25,1.34c-.9-.14-1.85-.21-2.8-.21l-1.63-1.62-1.65,.26-1.65,.26,.06,1.87c-.83,.27-1.57,.61-2.22,1l-3.13-.49-.74,.76-.94-.53v1.48l2.33,1.31c-.24,.52-.36,1.07-.34,1.62l-2.18,.73-.62-1.28v1.48l.46,.95,.46,.95,3.23-.02c.48,.48,1.07,.92,1.75,1.29l-.24,.52-.59-.19v1.48l1.49,.49,1.49,.49,2.25-1.34c.91,.14,1.85,.22,2.81,.21l1.62,1.62,1.65-.26,1.65-.26v-1.48h-.04s-.01-.38-.01-.38c.83-.28,1.58-.62,2.23-1.01l3.13,.49,.84-.86,.84-.86v-1.48l-.94,.96-1.39-.78c.24-.52,.36-1.07,.34-1.62l2.79-.93Zm-11.39,4.17c-3.01,.48-6.13-.55-6.97-2.29-.84-1.74,.92-3.54,3.93-4.02,3.01-.48,6.13,.55,6.97,2.29,.84,1.74-.92,3.54-3.93,4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M235.25,238.85s0,.02,0,.03v.06h0c0,.11,.03,.22,.08,.33,.35,.73,1.67,1.17,2.94,.97,1.04-.16,1.72-.7,1.74-1.29h0v-1.52h-4.77v1.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M246.39,234.51c-.48-.48-1.07-.91-1.75-1.29l.83-1.81-1.49-.49-1.49-.49-2.25,1.34c-.9-.14-1.85-.21-2.8-.21l-1.63-1.62-1.65,.26-1.65,.26,.06,1.87c-.83,.27-1.57,.61-2.22,1l-3.13-.49-.84,.86-.84,.86,2.33,1.31c-.24,.52-.36,1.07-.34,1.62l-2.8,.93,.46,.95,.46,.95,3.23-.02c.48,.48,1.07,.92,1.75,1.29l-.83,1.81,1.49,.49,1.49,.49,2.25-1.34c.91,.14,1.85,.22,2.81,.21l1.62,1.62,1.65-.26,1.65-.26-.06-1.87c.83-.28,1.58-.62,2.23-1.01l3.13,.49,.84-.86,.84-.86-2.33-1.31c.24-.52,.36-1.07,.34-1.62l2.79-.93-.46-.95-.46-.95-3.23,.02Zm-7.23,6.06c-3.01,.48-6.13-.55-6.97-2.29-.84-1.74,.92-3.54,3.93-4.02s6.13,.55,6.97,2.29-.92,3.54-3.93,4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M239.93,237.05c.35,.73-.39,1.49-1.66,1.69-1.27,.2-2.58-.23-2.94-.97-.35-.73,.39-1.49,1.66-1.69,1.27-.2,2.58,.23,2.94,.97Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "217.86 350.47 172.57 324.33 222.52 295.66 267.52 321.53 217.86 350.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "172.57 324.33 217.86 350.47 267.52 321.53 267.44 333.52 217.71 362.55 172.57 336.15 172.57 324.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "217.86 350.47 217.71 362.55 267.44 333.52 267.52 321.53 217.86 350.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "267.5 325.29 217.81 354.23 172.57 327.88 172.57 330.04 217.71 356.4 267.48 327.46 267.5 325.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "218.14 320.13 178.66 297.34 222.21 272.34 261.43 294.89 218.14 320.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "178.66 297.34 218.14 320.13 261.43 294.89 261.36 321.94 218.01 347.25 178.66 324.24 178.66 297.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "184.18 298.7 221.83 276.94 256.14 296.94 256.09 295.52 221.75 275.47 184.18 297.38 184.18 298.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "218.14 320.13 218.01 347.25 261.36 321.94 261.43 294.89 218.14 320.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "218.08 332.76 218.05 338.62 261.36 313.33 261.43 307.49 218.08 332.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "218.08 332.76 218.05 338.64 178.66 315.61 178.66 309.81 218.08 332.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M239.92,294.82c.24,3.95-4.34,7.67-11.99,9.09-9.74,1.81-20.77-.78-24.62-5.8-.94-1.22-1.36-2.48-1.33-3.7h0s0,4.15,0,4.15l.05,.04c.13,.97,.55,1.95,1.29,2.91,3.85,5.01,14.88,7.61,24.62,5.8,7.42-1.38,11.95-4.92,12-8.74h0v-3.75h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M238.6,291.55c3.85,5.01-.92,10.55-10.67,12.36-9.74,1.81-20.77-.78-24.62-5.8-3.85-5.01,.92-10.55,10.67-12.36,9.74-1.81,20.77,.78,24.62,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M239.17,292.41c-.16-.29-.35-.58-.57-.86-3.85-5.01-14.88-7.61-24.62-5.8-9.74,1.81-14.52,7.34-10.67,12.36,.14,.18,.28,.35,.43,.52,6.82-3.74,20.42-9.69,35.43-6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M213.27,287.63c9.96-1.8,21.22,.77,25.23,5.74-.13-.21-.26-.42-.42-.62-3.74-5.01-14.46-7.6-23.94-5.79-2.91,.56-5.35,1.46-7.25,2.6,1.78-.83,3.92-1.49,6.37-1.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M218.84,296.67c.44-.19,.71-.39,.81-.62,.1-.22,.07-.52-.09-.91s-.29-.74-.39-1.09c-.1-.34-.11-.66-.04-.97s.24-.59,.51-.85c.27-.26,.69-.52,1.26-.76,.95-.4,1.95-.57,3.02-.5,1.06,.07,2.02,.37,2.87,.88l1.78-.76,.94,.7-1.81,.77c.57,.6,.71,1.2,.43,1.8-.28,.6-.96,1.13-2.02,1.58l-1.99-1.49c.58-.25,.95-.5,1.11-.75,.16-.25,.09-.48-.2-.7-.26-.19-.58-.29-.95-.3-.38,0-.77,.08-1.18,.25-.42,.18-.66,.38-.74,.61s-.05,.52,.1,.89c.14,.37,.26,.72,.35,1.07s.1,.67,.03,.97c-.07,.3-.24,.59-.51,.86-.27,.27-.69,.53-1.26,.77-.96,.41-1.96,.58-2.99,.52-1.03-.06-1.97-.34-2.8-.85l-1.69,.72-.94-.7,1.7-.72c-.73-.69-.97-1.36-.72-2.01,.25-.64,.96-1.21,2.12-1.71l1.99,1.48c-.64,.27-1.03,.55-1.16,.84-.14,.29-.02,.57,.35,.84,.27,.2,.59,.31,.97,.33,.38,.02,.77-.06,1.17-.23Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c699deeebb2074ecbf8b92ef6ee9a739.svg";
export { ForwardRef as ReactComponent };